import { render, staticRenderFns } from "./crudProject.vue?vue&type=template&id=62706b80&scoped=true&"
import script from "./crudProject.vue?vue&type=script&lang=js&"
export * from "./crudProject.vue?vue&type=script&lang=js&"
import style0 from "./crudProject.vue?vue&type=style&index=0&id=62706b80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62706b80",
  null
  
)

export default component.exports